export default "__VITE_ASSET__De6itVMN__"